import React, { useState } from 'react';
import ReactLoader from 'react-loading';

import { ThemeProps, withTheme } from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as GuestIcon } from 'assets/images/invite.svg';
import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import UserList from 'components/UserList';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { GroupedListModel } from 'models/groupedList';
import GuestForm from 'screens/containers/GuestForm';
import { Guest } from 'services/userGuestService';
import { clickSelectUserInvite } from 'action-creators/eventsBooking';
import { Container, Content, Label, Value, GuestTag } from './styles';
import { useDispatch } from 'react-redux';

interface TravelArrangerSelectProps extends ThemeProps<any> {
  title: string;
  buttonLabel: string;
  addGuestLabel: string;
  value?: GroupedListModel[];
  options: GroupedListModel[];
  disabled?: boolean;
  inviteAllowed?: boolean;
  onChange: (value: GroupedListModel[]) => void;
  onCreateGuest: (value: Guest) => void;
  isLoading: boolean;
  testId?: string;
  singleSelect: boolean;
  maxSelectedItems?: number;
  maxSelectedItemsByHotel?: boolean;
}

const TravelArrangerSelect = ({
  title,
  buttonLabel,
  addGuestLabel,
  disabled,
  value,
  options,
  onChange,
  onCreateGuest,
  inviteAllowed,
  isLoading,
  testId,
  singleSelect,
  maxSelectedItems,
  maxSelectedItemsByHotel
}: TravelArrangerSelectProps) => {
  const { t } = useStoreTranslation();
  const [showUserList, setShowUserList] = useState(false);
  const [showGuestForm, setShowGuestForm] = useState(false);
  const dispatch = useDispatch();

  const handleShowUserList = () => {
    setShowUserList(true);
    dispatch(clickSelectUserInvite());
  };

  const handleCloseUserList = () => {
    setShowUserList(false);
  };

  const handleSaveGuest = (guest: Guest) => {
    onCreateGuest(guest);
    handleCloseUserList();
  };

  return (
    <>
      <Container>
        <Content onClick={() => (disabled ? null : handleShowUserList())} data-testid={testId}>
          <Label>{title}</Label>
          <Value active={!!value}>
            {isLoading ? (
              <ReactLoader type="spin" color={ColorPalette.HEX.Gainsboro} width={24} height={24} />
            ) : (
              <>
                {`${(value && value[0]?.name) || title} ${(value && value[0]?.lastName) || ''} ${
                  value && value.length > 1 ? '+ ' + (value.length - 1) : ''
                }`}
                {value && value[0]?.entity === 'guest' && (
                  <GuestTag>
                    <GuestIcon />
                    {t('guestForm.guestTag')}
                  </GuestTag>
                )}
              </>
            )}
          </Value>
        </Content>
        <img src="/corporate/images/right-arrow.svg" alt="right-arrow" />
        <ApplicationOverlayContent sidebar show={showUserList} onClose={handleCloseUserList}>
          <UserList
            title={title}
            userList={options}
            onConfirmSelection={(values) => onChange(values)}
            onCloseSelectionScreen={handleCloseUserList}
            alreadySelected={value ? value : []}
            isLoading={isLoading}
            selectableType="check"
            singleSelect={singleSelect}
            isModal
            buttonLabel={buttonLabel}
            noAdd={!inviteAllowed}
            onAdd={() => setShowGuestForm(true)}
            addLabel={addGuestLabel}
            addIcon="/corporate/images/guest-act.svg"
            hasFavorites
            userSelectionOrigin="travelArranger"
            maxSelectedItems={maxSelectedItems}
            maxSelectedItemsByHotel={maxSelectedItemsByHotel}
          />
        </ApplicationOverlayContent>
      </Container>
      <GuestForm show={showGuestForm} onSaveTraveler={handleSaveGuest} onClose={() => setShowGuestForm(false)} />
    </>
  );
};

export default withTheme(TravelArrangerSelect);
